module.exports = __webpack_public_path__ + "static/pair-programming-8f3cf98cde9bf8fff9f920ca193800db.jpg";